import { create } from 'zustand';

export type SelectedItem = { id: string; type: 'localization' | 'recording' };

type SelectedItemsStore = { items: SelectedItem[] };

const initialState: SelectedItemsStore = { items: [] };

export const useSelectedItemsStore = create<SelectedItemsStore>(() => initialState);

export const toggleSelectedItem = (item: SelectedItem) => {
  useSelectedItemsStore.setState((state) => {
    const exists = state.items.some((i) => i.id === item.id && i.type === item.type);
    return {
      items: exists ? state.items.filter((i) => !(i.id === item.id && i.type === item.type)) : [...state.items, item],
    };
  });
};

export const resetSelectedItems = () => {
  useSelectedItemsStore.setState(initialState);
};

export const splitSelectedByType = (): { projectIds: string[]; recordingIds: string[] } => {
  const { items } = useSelectedItemsStore.getState();
  const projectIds: string[] = [];
  const recordingIds: string[] = [];
  for (const item of items) {
    if (item.type === 'recording') recordingIds.push(item.id);
    else projectIds.push(item.id);
  }
  return { projectIds, recordingIds };
};
